import { CloseCircleOutlined } from "@ant-design/icons";
import { Box, Card, CardContent, Container, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { PaymentAPIService } from "../../services/api";

export default function Cancel() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  useEffect(() => {
    async function getUpdatedStatus() {
      if (!sessionId) return;
      await PaymentAPIService.getUpdatedStatus(sessionId);
    }
    getUpdatedStatus();
  }, [sessionId]);
  return (
    <Container maxWidth="sm" sx={{ mt: 10 }}>
      <Card variant="outlined" sx={{ textAlign: "center", p: 4 }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <CloseCircleOutlined style={{ fontSize: "60px", color: "#d32f2f" }} />
        </Box>
        <CardContent>
          <Typography variant="h4" color="error" gutterBottom>
            Payment Failed
          </Typography>
          <Typography variant="body1">
            Your payment was not completed. Please try again or contact support for assistance.
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}